export default {
    categories: [
        {
            icon:"home",
            key:"home",
            route:"home",
            title:'Ana Sayfa' 
        },
        {
            icon:"settings",
            key:"system-management",
            title:'Sistem Yönetimi' 
        },
        // {
        //     icon:"construction",
        //     key:"system-parameter",
        //     title:'Sistem Değişkenleri' 
        // },
        
        {
            icon:"credit_card",
            key:"payment-process",
            title:'Ödeme İşlemleri' 
        },
        {
            icon:"payments",
            key:"payments",
            route:'payments',
            title:'Ödemeler' 
        },
    ],
    items:[
        {
            category:'system-management',
            icon:'people',
            route:'user',
            title:'Kullanıcılar'
        },
        // {
        //     category:'system-management',
        //     icon:'mail_lock',
        //     route:'mail-setting',
        //     title:'E-Posta Ayarları'
        // },
        // {
        //     category:'system-management',
        //     icon:'settings_accessibility',
        //     route:'role',
        //     title:'Rol Yönetimi'
        // },
        // {
        //     category:'system-management',
        //     icon:'dns',
        //     route:'system-parameter',
        //     title:'Sistem Parametreleri'
        // },
        {
            category:'system-management',
            icon:'account_balance',
            route:'bank-integration',
            title:'Banka Entegrasyonu'
        },
        {
            category:'payment-process',
            icon:'credit_card',
            route:'sent-payment-request',
            title:'Ödeme Hareketleri'
        },
    ]
}
